import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, withStyles, AppBar, Typography, Toolbar } from 'material-ui';
import PassengerCountersHeaderStyles from './PassengerCountersHeaderStyles';
import ArrowLeftIcon from '../../../icons/ArrowLeftIcon';
import Dictionary from '../../../model/Dictionary';
import Constants from '../../../model/AppConfiguration';

const PassengerCountersHeader = ({ selectedTrip, handleClose, classes }) => (
  <AppBar
    position='static'
    style={{ width: '100%', backgroundColor: 'transparent', color: 'rgba(0, 0, 0, 0.54)' }}
  >
    <Toolbar>
      <IconButton color='inherit' onClick={handleClose} aria-label='Close'>
        <ArrowLeftIcon className='navbar-arrow-icon' color='rgba(0, 0, 0, 0.54)' />
      </IconButton>
      <Typography type='title' color='inherit' className={classes.flex}>
        {Constants.flights.oneWay === selectedTrip.id ?
          Dictionary.flights.passengersSelection :
          Dictionary.flights.passengersSelection}
      </Typography>
    </Toolbar>
  </AppBar>
);

PassengerCountersHeader.propTypes = {
  selectedTrip: PropTypes.object,
  handleClose: PropTypes.func,
  classes: PropTypes.object,
};

export default withStyles(PassengerCountersHeaderStyles)(PassengerCountersHeader);



// WEBPACK FOOTER //
// ./src/components/flights/passengerCounters/PassengerCountersHeader.js